/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { fecthLapseRenewal, fecthRenewAsIs, fecthRenewPolicy } from '../../../../actions'

/**
 * Import
 * - Page component
 */
import Summary from '../../../../components/pages/Renewals/Summary/Summary'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        renewAsIs: state.renewals.renewAsIs,
        renewPolicy: state.renewals.renewPolicy,
        lapseRenewal: state.renewals.lapseRenewal,
    }
}

export default connect(
    mapStateToProps,
    {
        fecthLapseRenewal,
        fecthRenewAsIs,
        fecthRenewPolicy,
    }
)(Summary)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Renewals/Summary/Summary.tsx